module.exports = __webpack_public_path__ + "media/images/universal_url_guide-cc6fa5fb097b6b8232977d904af48ce1.png";